import React, { useState, useEffect, useRef } from 'react';

export default function TextInput(props) {
  const [value, setValue] = useState(props.value);
  const inputRef = useRef(null);
  useEffect(() => {
    setValue(props.value);
  }, [props]);
  function isLessThanZero(value) {
    if (value < 0) {
      return true;
    }
    return false;
  }
  function onChange(e) {
    e.preventDefault();
    e.stopPropagation();
    if (props.type === 'number') {
      if (isLessThanZero(parseInt(e.target.value)) || isNaN(parseInt(e.target.value))) {
        setValue('0');
      }
      setValue(parseInt(e.target.value).toString());
      return;
    }
    setValue(e.target.value);
  }
  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (props.onFocus) {
      if (!props.onFocus(e)) {
        inputRef.current.blur();
      }
    }
  }
  function enterDetector(e) {
    // if enter key is pressed lose focus
    if (e.which === 13 || e.keyCode === 13) {
      inputRef.current.blur();
    }
  }
  function onBlur(e) {
    e.preventDefault();
    e.stopPropagation();
    if (props.type === 'number') {
      props.onChange({ ...props, value: parseInt(value), id: props.id });
    } else {
      props.onChange({ ...props, value: value, id: props.id });
    }
  }
  return (
    <input
      id={`textinput-${value}-areaschedule`}
      data-testid={`textinput-${value}-areaschedule`}
      ref={inputRef}
      onClick={onClick}
      type={props.type}
      className="textareaSchedule"
      value={value}
      onKeyUp={enterDetector}
      onBlur={onBlur}
      onChange={onChange}
      disabled={props.disabled}
      title={props.title}
    />
  );
}
